import { render, staticRenderFns } from "./activity-transaction.vue?vue&type=template&id=2cf1f23e"
import script from "./activity-transaction.vue?vue&type=script&lang=js"
export * from "./activity-transaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports